// ContentSourceStatus — indica no Dashboard admin se a fonte editorial
// (landing cemedeiros.com.br) está online ou se o app está em modo
// resiliente (servindo o último conteúdo válido em cache persistente).
import React, { useEffect, useState } from "react";
import { Globe, ShieldAlert, CloudOff, RefreshCw } from "lucide-react";
import { api } from "../../lib/api";

const MODES = {
  online: {
    label: "Fonte editorial online",
    detail: "O conteúdo está sendo servido diretamente da landing.",
    cls: "bg-emerald-50 border-emerald-200 text-emerald-800",
    Icon: Globe,
  },
  resilient: {
    label: "Modo resiliente ativo",
    detail: "Landing indisponível. Servindo o último conteúdo válido em cache.",
    cls: "bg-amber-50 border-amber-300 text-amber-900",
    Icon: ShieldAlert,
  },
  offline: {
    label: "Fonte editorial indisponível",
    detail: "Landing fora do ar e sem cache válido. Blocos afetados ficam ocultos.",
    cls: "bg-red-50 border-red-200 text-red-800",
    Icon: CloudOff,
  },
};

export const ContentSourceStatus = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/content-source/status");
      setData(r.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  if (loading && !data) return null;
  if (!data) return null;

  const mode = MODES[data.mode] || MODES.offline;
  const Icon = mode.Icon;
  const servable = (data.snapshots || []).filter((s) => s.servable).length;

  return (
    <div
      className={`border rounded-2xl px-4 py-3 mb-6 flex items-start gap-3 ${mode.cls}`}
      data-testid="content-source-status"
    >
      <Icon className="w-5 h-5 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium" data-testid="content-source-mode">{mode.label}</p>
        <p className="text-xs opacity-80 mt-0.5">{mode.detail}</p>
        <p className="text-[11px] opacity-70 mt-1">
          {data.landing_base} · {servable} snapshot(s) válido(s)
          {data.last_success_at && ` · última sincronização: ${new Date(data.last_success_at).toLocaleString("pt-BR")}`}
        </p>
      </div>
      <button
        type="button"
        onClick={load}
        aria-label="Atualizar status da fonte"
        data-testid="content-source-refresh"
        className="p-2 rounded-full hover:bg-white/50 shrink-0"
      >
        <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
      </button>
    </div>
  );
};
